import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProcessingContracts } from './ProcessingContracts';

export const TeamPerformanceNotReady: FC = () => {
  const navigate = useNavigate();

  return (
    <ProcessingContracts
      ctaButtonText="Browse properties"
      description={`We will notify you when it’s ready.
In the meantime try browsing our listing level offer data.`}
      title="We’re processing your data"
      onCTAClick={() => {
        navigate('/map');
      }}
    />
  );
};
